// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var PropertyLocationMap = require("../../common/Property/PropertyLocationMap.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayPreviewLocation_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewLocation_localDraft_graphql.bs.js");
var PropertyWizardRelayPreviewLocation_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewLocation_displayHelpers_graphql.bs.js");

var convertFragment = PropertyWizardRelayPreviewLocation_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewLocation_displayHelpers_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewLocation_displayHelpers_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewLocation_displayHelpers_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewLocation_displayHelpers_graphql.node, convertFragment, fRef);
}

var DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayPreviewLocation_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewLocation_localDraft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewLocation_localDraft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewLocation_localDraft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewLocation_localDraft_graphql.node, convertFragment$1, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Preview__Location(props) {
  var displayHelpers = use(props.displayHelpers);
  var draft = use$1(props.draft);
  var $$location = Core__Option.getOr(draft.draftProperty.hideAddress, false) ? Core__Option.map(displayHelpers.hiddenPropertyLocation, (function (x) {
            return x.fragmentRefs;
          })) : Core__Option.map(displayHelpers.propertyLocation, (function (x) {
            return x.fragmentRefs;
          }));
  if ($$location !== undefined) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("h2", {
                        children: "Location",
                        className: "text-2xl font-medium text-gray-800"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(PropertyLocationMap.FromPropertyLocation.make, {
                              propertyLocation: Caml_option.valFromOption($$location)
                            }),
                        className: "my-6"
                      })
                ]
              });
  } else {
    return null;
  }
}

var MissingFieldMarker;

var Validators;

var make = PropertyWizardRelay__Preview__Location;

exports.MissingFieldMarker = MissingFieldMarker;
exports.Validators = Validators;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
